export default __webpack_public_path__ + "static/media/gallery_01.d62f8fa0.jpg";